module.exports = __webpack_public_path__ + "static/img/consultant_square.c90e106.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/consultant_square.png
// module id = G6vB
// module chunks = 1